import { render, staticRenderFns } from "./AccreditationOngoingProjectBox.vue?vue&type=template&id=07e9158a&scoped=true"
import script from "./AccreditationOngoingProjectBox.vue?vue&type=script&lang=js"
export * from "./AccreditationOngoingProjectBox.vue?vue&type=script&lang=js"
import style0 from "./AccreditationOngoingProjectBox.vue?vue&type=style&index=0&id=07e9158a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e9158a",
  null
  
)

export default component.exports